<template>
  <div class="download container">
    <div class="download__content">
      <h3 class="download__title">Clipboard for iOS and Mac OS</h3>
      <p class="download__text">
        Available for free on the App Store. Download for Mac or iOS, sync with iCloud
        and you’re ready to start adding to your clipboard.
      </p>
    </div>
    <div class="download__cta">
      <Button value="Download for iOS" type="primary" />
      <Button value="Download for Mac" />
    </div>
  </div>
</template>

<script>
import Button from './reusable/Button.vue';

export default {
  components: {
    Button,
  },
};
</script>

<style lang="scss" scoped>
// $breakpoints
$desktop-media-1: 50em;

.download {
  margin-top: var(--bg-spacer);
  &__title {
    font-size: var(--fs-h1);
    font-weight: var(--fw-bold);
    margin-bottom: calc(var(--sm-spacer) / 4);
    line-height: 1.2;
  }

  &__text {
    margin: 0 auto calc(var(--sm-spacer));
    max-width: var(--text-width);
    color: var(--grayish-blue);
  }

  &__cta {
    .button + .button {
      margin-top: calc(var(--sm-spacer) / 2);
      @media (min-width: $desktop-media-1) {
        margin: 0;
      }
    }

    @media (min-width: $desktop-media-1) {
      display: flex;
      gap: calc(var(--sm-spacer) / 2);
      justify-content: center;
    }
  }
}

</style>
